import store from '../configureStore';
import { apiGet, apiPost } from './apiUtil';

export const getFolders = () => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const headersObj = { headers: header };
  return apiGet(`/folder?gid=${currentUserGroup}`, headersObj);
};

export const getFolderById = (subfolderId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const headersObj = { headers: header };
  return apiGet(
    `/folder/${subfolderId}?gid=${currentUserGroup}`,
    headersObj,
  );
};

export const getFolderContentIdsList = (subfolderId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const getFolderContentIdsListInit = { headers: header };
  return apiGet(
    `/folder/${subfolderId}?gid=${currentUserGroup}&min=1`,
    getFolderContentIdsListInit,
  );
};

export const deleteFolder = (folderId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const deleteFolderInit = {
    headers: header,
    body: `id=${folderId}`,
  };
  return apiPost(
    `/resource/delete?gid=${currentUserGroup}&id=${folderId}`,
    deleteFolderInit,
  );
};
